var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',_vm._b({on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},'el-tabs',_vm.$attrs,false),_vm._l((_vm.tabsTitle),function(item,index){return _c('el-tab-pane',{key:index,attrs:{"label":item.label,"name":item.name}},[_vm._t(item.name)],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }